import React from "react";
import { DefinitionFilterContainer } from "../../../containers";

const LoadFilter = (props) => {
  return <DefinitionFilterContainer {...props} />;
};

export default LoadFilter;
